import * as React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import styled from 'styled-components';
import TabContext from '@mui/lab/TabContext';
import { TreeView } from '@mui/lab';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {Box, Grid, Button, TextField, Stack, Typography, Modal, IconButton} from '@mui/material';
import FileCard from './components/fileCard';
import FolderItem from './components/folderItem';
import AddDocument from '../forms/AddDocument';
import AddFolder from '../forms/AddFolder';
import { REPOSITORY } from '../../../constants/repository';
import {deleteResource, getFolderInfo} from '../../../api/repositorio';
import { useFinder } from '../../../hooks/useFinder';
import { StyleModal } from '../../modal/styles';
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import FolderCard from "./components/folderCard";

const FolderContents = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-gap: 0px;
`;

const TitleFolder = styled.h2`
  font-size: 18px;
  font-weight: 600;
`;

export default function Index({ mainDirectory, setRefreshMainDirectory }) {
  const { keycloak } = useKeycloak();
  const userRole = keycloak.resourceAccess.puv.roles[0];

  const [value, setValue] = React.useState('');
  const [tabSelectedInfo, setTabSelectedInfo] = React.useState({
    parentId: null,
    name: '',
    tabId: '',
    files: [],
    subFolders: [],
  });

  const [filterName, setFilterName] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [contentModal, setContentModal] = React.useState('');

  const handleChange = (event, newValue) => setValue(newValue);
  const handleClose = () => {
    setOpen(false);
    setRefreshMainDirectory(true);
  };

  const tabSelectedHandle = (tabId) => {
    getFolderInfo(tabId, keycloak?.tokenParsed?.sub)
      .then((data) => {
        setTabSelectedInfo({
          parentId: data.idParent,
          name: data.name,
          tabId: tabId.toString(),
          files: data.files,
          subFolders: data.subFolders,
        });
      })
      .catch((error) => console.error('Error fetching folder info:', error));
  };

  const filterFolders = (folders, role) => {
    return folders?.filter(folder => {
      // Filtrar carpetas privadas si el usuario es 'Usuario'
      if (role === 'Usuario' && folder.private) {
        return false;
      }

      // Si hay subcarpetas, aplicar el filtro de forma recursiva
      if (folder.children) {
        folder.children = filterFolders(folder.children, role);
      }

      return true;
    });
  };

  const sortedFolders = React.useMemo(() => {
    const filteredFolders = filterFolders(mainDirectory, userRole); // Aquí se usa userRole del ámbito superior

    return filteredFolders?.slice().sort((a, b) => a.nameDirectory.localeCompare(b.nameDirectory));
  }, [mainDirectory, userRole]);
  
  const { files, subFolders } = tabSelectedInfo;
  let prevFilteredFiles = [];

  if (userRole === 'Usuario') {
    if (files !== null) {
      const publicFiles = files.filter((item) => item?.isPrivate === false);
      const aprrovedFiles = publicFiles.filter((item) => item?.fileStatus?.id === 2);
      prevFilteredFiles = aprrovedFiles;
    }
  } else {
    prevFilteredFiles = files;
  }

  const filteredFiles = useFinder(filterName, prevFilteredFiles);
  
  const handleDeleteFolder = () =>{
    Swal.fire({
      title: "Estás a punto de eliminar la carpeta y su contenido.",
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const parentId = tabSelectedInfo?.parentId;
          deleteResource(tabSelectedInfo?.tabId, 0)
            .then((response) => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Carpeta eliminada con éxito.',
                showConfirmButton: false,
                timer: 1200,
              });
              setRefreshMainDirectory(true);
              getFolderInfo(parentId, keycloak?.tokenParsed?.sub)
                .then(({data}) => {
                  setTabSelectedInfo({
                    parentId: data?.data?.idParent,
                    name: data?.data?.name,
                    tabId: parentId.toString(),
                    files: data?.data?.files,
                    subFolders: data?.data?.subFolders,
                  });
                })
                .catch((error) => console.error('Error fetching folder info:', error));
            }).catch((error) => {
              console.error('Error al eliminar carpeta:', error)
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Error al eliminar carpeta',
              text: 'Hubo un problema al eliminar la carpeta. Por favor, inténtalo de nuevo más tarde.',
            });
          });
          
        } catch (error) {
          console.error('Error al eliminar el usuario:', error);
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar carpeta',
            text: 'Hubo un problema al eliminar la carpeta. Por favor, inténtalo de nuevo más tarde.',
          });
        }
      }
    });
  };
  
  return (
    <TabContext value={value}>
      <Grid container spacing={0}>
        <Grid item xs={3}>
          {/* List of tabs */}
          <TreeView
            aria-label="file repository navigator"
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
            sx={{ height: '65vh', flexGrow: 1, maxWidth: '95%', overflowY: 'auto' }}
          >
            {sortedFolders?.map((folder) => (
              <FolderItem key={folder.id} folder={folder} tabSelectedHandle={tabSelectedHandle} />
            ))}
          </TreeView>
        </Grid>
        <Grid item xs={9}>
          <Box>
            {/* Tab Content Selected */}
            {!!tabSelectedInfo.tabId.length && (
              <Box>
                <Stack direction="row" alignItems="center" mb={3}>
                  {/* <Box>
                      {tabSelectedInfo.parentId !== 0 && (
                        <IconButton sx={{ marginRight: '5px' }} onClick={() => tabSelectedHandle(tabSelectedInfo.parentId)}>
                          <ArrowBackIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box> */}
                  <Grid item xs={6}>
                  <Box>
                    <TitleFolder>{tabSelectedInfo.name}</TitleFolder>
                  </Box>
                  </Grid>
                  {userRole === 'Autor' && (
                    <Grid item xs={6}>
                      <Box>
                        <Button
                          sx={{ marginRight: '10px' }}
                          variant="contained"
                          color="error"
                          startIcon={<DeleteOutline />}
                          onClick={handleDeleteFolder}
                        >
                          Carpeta
                        </Button>
                        <Button
                          sx={{ marginRight: '10px' }}
                          variant="contained"
                          color="primary"
                          startIcon={<AddIcon/>}
                          onClick={() => {
                            setContentModal(REPOSITORY.FOLDER);
                            setOpen(true);
                          }}
                        >
                          Carpeta
                        </Button>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<AddIcon/>}
                          onClick={() => {
                            setContentModal(REPOSITORY.DOCUMENT);
                            setOpen(true);
                          }}
                        >
                          Documento
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </Stack>
                <Grid container spacing={2} alignItems="flex-start" justifyContent="space-between">
                  <Grid item xs={6}>
                    <Box mb={3}>
                      {/* <TitleSearch>Buscar documento</TitleSearch> */}
                      <TextField
                        variant="outlined"
                        onChange={(e) => setFilterName(e.target.value)}
                        fullWidth
                        placeholder="Escriba el nombre del documento"
                        disabled={filteredFiles === null}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Box>
                  <FolderContents>
                    {/* Subfolders */}
                    {!!subFolders.length &&
                      subFolders.map((subfolder) => (
                        <FolderCard {...subfolder} tabId={tabSelectedInfo.tabId} tabSelectedHandle={tabSelectedHandle} />
                      ))} 
                    {/* Files */}
                    {filteredFiles?.length  > 0 && (
                      <>
                        {filteredFiles.map((file) => (
                          <FileCard {...file} tabId={tabSelectedInfo.tabId} tabSelectedHandle={tabSelectedHandle} />
                        ))}
                      </>
                    )}
                  </FolderContents>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
      {/* Modal */}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={StyleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {contentModal === REPOSITORY.FOLDER ? 'Crear Carpeta' : 'Subir Documento'}
          </Typography>
          {contentModal === REPOSITORY.FOLDER ? (
            <AddFolder
              folderId={tabSelectedInfo?.tabId}
              handleClose={handleClose}
              fromDirectory={false}
              tabSelectedHandle={tabSelectedHandle}
            />
          ) : (
            <AddDocument
              updateDoc={false}
              folderId={tabSelectedInfo?.tabId}
              handleClose={handleClose}
              tabSelectedHandle={tabSelectedHandle}
            />
          )}
        </Box>
      </Modal>
    </TabContext>
  );
}
